/**
 * @file location.schema.ts
 * @description Define o schema Zod para a entidade 'Location'.
 * Um Location é um local físico de atendimento (consultório, clínica, unidade de laboratório).
 * É uma entidade de primeira classe, gerenciada em um painel de administração.
 */

import { z } from 'zod';

// --- Helper Schemas & Enums ---

const AddressSchema = z.object({
  street: z.string(),
  number: z.string(),
  complement: z.string().nullable(),
  neighborhood: z.string(),
  city: z.string(),
  state: z.string().length(2),
  postalCode: z.string(),
  googleMapsPlaceId: z.string().nullable(),
});

const ContactSchema = z.object({
  phone: z.string().nullable(), // Agora obrigatório (não opcional)
  whatsapp: z.boolean(), // true se o número tem WhatsApp, false caso não
});


// --- Main Location Schema ---

const LocationSchema = z.object({
  // Nome de exibição do local. Ex: "Clínica Bem-Estar - Unidade Paulista".
  name: z.string(),
  
  // Endereço e Contato do local específico.
  address: AddressSchema,
  contact: ContactSchema,

  // Array com os IDs dos parceiros que credenciam ESTE local específico.
  affiliatedPartnerIds: z.array(z.string()),
  
  // Tags para busca regional. Agora pertencem aqui, pois a região é do local.
  regionTags: z.array(z.string()).optional(),

  // Campos de auditoria.
  createdAt: z.date(),
  updatedAt: z.date(),
  deletedAt: z.date().nullable(),
});


// --- Inferred TypeScript Types ---

type Location = z.infer<typeof LocationSchema>;
type Address = z.infer<typeof AddressSchema>;
type Contact = z.infer<typeof ContactSchema>;


// --- Public Exports ---

export { LocationSchema, AddressSchema, ContactSchema };
export type { Location, Address, Contact };